import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './MessageForm.css';
import SubmitIcon from './icon-submit.svg';
import AddMediaIcon from './icon-add-media.svg';
import ExpandableTextarea from 'components/ExpandableTextarea';

export const MESSAGE_TYPE_POST = 'post';
export const MESSAGE_TYPE_COMMENT = 'comment';
export const MESSAGE_TYPE_CHAT = 'chat';
export const MESSAGE_TYPE_IMAGE_CAPTION = 'caption';

const MESSAGE_PLACEHOLDER_TEXTS = {
  [MESSAGE_TYPE_POST]: 'Share your thoughts…',
  [MESSAGE_TYPE_COMMENT]: 'Write a comment…',
  [MESSAGE_TYPE_CHAT]: 'Type here to chat…',
  [MESSAGE_TYPE_IMAGE_CAPTION]: 'Type your message…'
};

class MessageForm extends Component {
  componentDidMount() {
    if (this.props.autoFocus && this.messageInput) {
      this.messageInput.focus();
    }
  }

  render() {
    const { onClick, onSubmit, disabled } = this.props;

    const submitDisabled =
      disabled !== 'undefined'
        ? disabled
        : this.props.message.length === 0 || this.props.disabled;

    return (
      <form onSubmit={onSubmit}>
        <ExpandableTextarea
          onChange={this.props.onChange}
          placeholder={MESSAGE_PLACEHOLDER_TEXTS[this.props.placeholder]}
          onKeyDown={this.props.onKeyDown}
          value={this.props.message}
          disabled={this.props.disabled}
          innerRef={input => (this.messageInput = input)}
        />
        <button className="add-message-media" onClick={onClick} type="button">
          <img
            className="add-media-button"
            alt="Submit media icon"
            src={AddMediaIcon}
          />
        </button>
        <button type="submit" disabled={submitDisabled}>
          <img
            className="add-comment-button"
            alt="Submit comment icon"
            src={SubmitIcon}
          />
        </button>
      </form>
    );
  }
}

MessageForm.propTypes = {
  onSubmit: PropTypes.func,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  message: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool
};

export default MessageForm;



// WEBPACK FOOTER //
// ./src/components/MessageForm/index.js